import React from 'react';

import { _isNotBlank } from '@/littledash';

import InlineEditInput from '@/components/UI/InlineEditInput/InlineEditInput';

import type { TreatmentGroup } from '@/model/TreatmentGroup.model';
import type { RecagingAnimal } from '../Recaging.utils';
import GroupLabel, { UnassignedGroupLabel } from '@/components/UI/GroupLabel/GroupLabel';
interface ProposedCageCardProps {
  cage: string;
  treatmentGroup: TreatmentGroup;
  animals: RecagingAnimal[];
  index: number;
  onChangeAnimalId: (newId: string, cageIndex: number, animalIndex: number) => void;
  onChangeCageName: (newCageName: string, cageIndex: number) => void;
}

const TH_CLASSES = 'f7 f6-l ph2 pv2 ph3-l pv3-l b--silver near-black basier-med normal';
const TD_CLASSES = 'f7 f6-l ph2 pv1 ph3-l pv2-l bt';

export const ProposedCageCard: React.FC<ProposedCageCardProps> = ({
  cage,
  treatmentGroup,
  animals,
  index: cageIndex,
  onChangeAnimalId,
  onChangeCageName,
}) => {
  return (
    <div className="ui-card mv4">
      <div className="flex flex-row pa3 justify-between items-center bb b--moon-gray">
        <div
          className="basier-med near-black normal f5 lh-solid dib v-mid"
          data-tooltip-id="global-tooltip-id"
          data-tooltip-content="Click to rename"
        >
          <InlineEditInput<string>
            value={cage}
            change={(value: Record<string, string>) => {
              onChangeCageName(_isNotBlank(value.text?.trim()) ? value.text : cage, cageIndex);
            }}
            propName="text"
            classInvalid="ui__error"
            className="f4 ui__editable"
          />
        </div>
        <div>
          {treatmentGroup.id === -1 ? (
            <UnassignedGroupLabel group={treatmentGroup} />
          ) : (
            <GroupLabel group={treatmentGroup} groupContextClassName={'pl1'} />
          )}
        </div>
      </div>

      <table className="w-100 tl bt b--moon-gray" style={{ borderSpacing: 0 }}>
        <thead className="bg-near-white">
          <tr>
            <th className={TH_CLASSES}>Old Animal ID</th>
            <th className={TH_CLASSES}>Old Cage ID</th>
            <th className={TH_CLASSES}>New Animal ID</th>
          </tr>
        </thead>
        <tbody>
          {animals.map(({ id, name, cage, newAnimalId }, animalIndex) => (
            <tr key={id}>
              <td className={TD_CLASSES}>{name}</td>
              <td className={TD_CLASSES}>{cage?.name || 'N/A'}</td>
              <td className={TD_CLASSES}>
                <input
                  value={newAnimalId}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    onChangeAnimalId(event.target.value, cageIndex, animalIndex);
                  }}
                  className="f4 ui__editable"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
